// extracted by mini-css-extract-plugin
export default {"app-qc":"QCPage_app-qc__1To4M","body":"QCPage_body__gjef8","duplicacy_text":"QCPage_duplicacy_text__K2xKJ","jump":"QCPage_jump__hnkkn"};